<template>
    <div class="p-6 justify-center items-center text-black">
        <img alt="lshtm-logo" src="https://publicapis.lshtm.ac.uk/global/logo?height=100" class="w-40 m-auto" />
        <div class="sm:w-full md:w-1/2 lg:w-1/3 m-auto">
            <form class="mt-8 bg-gray-100 overflow-hidden border" @submit.prevent="login">
                <div class="px-10 py-12">
                    <h1 class="text-black font-bold text-3xl mb-4">Applicant Portal - Login</h1>
                    <p class="mb-6">
                        Please read the Online Application <a class="text-green-500 underline hover:text-orange-600" href="https://www.lshtm.ac.uk/study/frequently-asked-questions/online-application-form-faqs" target="_blank">FAQ</a>/<a class="text-green-500 underline hover:text-orange-600" href="https://www.lshtm.ac.uk/files/msc-application-guidance.pdf" target="_blank">Guidance</a> before commencing your application.
                        Please visit our <a class="text-green-500 underline hover:text-orange-600" href="https://www.lshtm.ac.uk/study/applications/" target="_blank">How to Apply</a> webpage for information on our application closing dates.
                    </p>

                    <div class="mx-auto mt-6 mb-6 w-24 border-b-2" />
                    <div v-if="successMessage" class="success-message">{{ successMessage }}</div>
                    <div v-if="serverError" class="server-error">{{ serverError }}</div>

                    <label class="block text-black-600 text-sm mb-2 text-left" for="username">
                        Email:
                    </label>
                    <input id="username" v-model="username" class="appearance-none border rounded border-gray-300 w-full py-2 px-3 text-black-600 leading-tight focus:outline-none focus:shadow-outline" label="Username" type="text" autofocus autocapitalize="off" />
          
                    <label class="block text-black-600 text-sm mb-2 mt-4 text-left" for="password">
                        Password:
                    </label>
                    <input id="password" v-model="password" class="appearance-none border rounded border-gray-300 w-full py-2 px-3 text-black-600 leading-tight focus:outline-none focus:shadow-outline" label="Password" type="password" autofocus autocapitalize="off" />

                    <router-link to="forgotPassword"> <p class="block text-black-600 text-sm mb-2 mt-4 text-left">I've forgotten my password.</p></router-link>
                    <div class="py-4 bg-gray-100 border-t border-gray-100 flex justify-between">
                        <router-link :to="{ name: 'Register' }"><div class="hover:bg-white border text-black-500 py-2 px-4 w-full rounded">Register</div></router-link>
                        <button class="bg-green-600 hover:bg-green-700 text-white py-2 px-4 w-full lg:w-1/2 rounded btn-submit" :disabled="loading" type="submit">
                            <div v-if="loading" class="lds-ring-container"><div class="lds-ring"><div /><div /><div /><div /></div></div>
                            Login
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>

export default {
    metaInfo: { title: 'Login' },
    name: 'Login',
    props: {
      dataSuccessMessage: {
        type: String,
      },
    },
    data() {
        return {
            username: '',
            password: '',
            loading: false,
            serverError: '',
            successMessage: this.dataSuccessMessage,
        }
    },
  created(){
    this.successMessage = this.$route.query.verified ? 'Your account was successfully verified.  Please log in' : this.dataSuccessMessage;
    this.serverError = this.$route.query.unverified ? 'Your account is not yet verified.  Please check your emails for further instructions' : '';

  },

    methods: {
        login() {
            this.loading = true,
            this.$store.dispatch('retrieveToken', {
              username: this.username,
              password: this.password,
            })
              .then(() => {
                this.loading = false
                this.$router.push({ name: 'Home' })
              })
              .catch(error => {
                this.loading = false
                this.serverError = error.response.data.error_description
                this.password = ''
                this.successMessage = ''
              })
        },
    },
}
</script>